import React from 'react'
import { aboutChardham } from '../Data/AboutCharDham'
import { Container } from 'react-bootstrap'

export default function AboutDham() {
  return (
    <>
    {
    aboutChardham.map((dham) => (

      <Container className='mt-5 p-4' style={{ background: '#44bbe3', boxShadow: '-1px 7px 8px 1px rgb(0 0 0 / 20%)', borderRadius: '10px', lineHeight: "30px", wordSpacing: "0.2rem" }}>
        <h2 style={{textAlign: "center", paddingBottom: "2rem"}}>{dham.title}</h2>
        <p>{dham.desc}</p>
        </Container>

    ))
    } 
    </>
  )
}
